// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.savings__wL2Bo {
  display: flex;
  margin-bottom: 20px;
}

.savingsBlock__tKvSE {
  flex: 0 0 25%;
  text-align: left;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.savingsCount__ZFioL {
  font-size: 18px;
  font-weight: 500;
  color: var(--legend-for-header-text);
  height: 20px;
}

.savingsCountText__K6uwR {
  font-size: 11px;
  text-transform: uppercase;
  color: var(--tables-secondary-row-sub-title-text);
  font-weight: 400;
}

.skeletonText__Xx_Ih {
  width: 65%;
  height: 20px;
}

.skeleton__z_rii {
  height: calc(100% - 130px);
  min-height: 397px;
}

.skeletonTab__loaRu {
  height: 35px;
}

.legend__qMsUp {
  pointer-events: none;
}
.legend__qMsUp span {
  color: var(--tables-title-text) !important;
  text-align: center;
  font-family: "Roboto", sans-serif !important;
  font-weight: 400;
  font-size: 11px !important;
  line-height: 120%;
  text-transform: uppercase;
}

.xAxisLabels__X_Dzc text,
.yAxisLabels__AF4HL text {
  fill: var(--header-icon-secondary) !important;
  font-weight: 400;
  line-height: normal;
}

.tabsBlock__r9j0d {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  align-items: center;
}

.tabContainer__s98Ev {
  width: 70%;
}
@media (max-width: 850px) {
  .tabContainer__s98Ev {
    width: 60%;
  }
}

.skeletonTab__loaRu {
  width: 100%;
  height: 45px;
}

.selectWrapper__W_rME {
  width: 130px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ExecutiveSummary/components/TotalCostSaving/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,yBAAA;EACA,iDAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,UAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,0BAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF;;AA4EA;EACE,oBAAA;AAzEF;AA0EE;EACE,0CAAA;EACA,kBAAA;EACA,4CAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,yBAAA;AAxEJ;;AA8EE;;EACE,6CAAA;EACA,gBAAA;EACA,mBAAA;AA1EJ;;AA8EA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,UAAA;AA3EF;AA4EE;EAFF;IAGI,UAAA;EAzEF;AACF;;AA4EA;EACE,WAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,YAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.savings {\n  display: flex;\n  margin-bottom: 20px;\n}\n\n.savingsBlock {\n  flex: 0 0 25%;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.savingsCount {\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--legend-for-header-text);\n  height: 20px;\n}\n\n.savingsCountText {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-weight: 400;\n}\n\n.skeletonText {\n  width: 65%;\n  height: 20px;\n}\n\n.skeleton {\n  height: calc(100% - 130px);\n  min-height: 397px;\n}\n\n.skeletonTab {\n  height: 35px;\n}\n\n.legend {\n  pointer-events: none;\n  span {\n    color: var(--tables-title-text) !important;\n    text-align: center;\n    font-family: 'Roboto', sans-serif !important;\n    font-weight: 400;\n    font-size: 11px !important;\n    line-height: 120%;\n    text-transform: uppercase;\n  }\n}\n\n.xAxisLabels,\n.yAxisLabels {\n  text {\n    fill: var(--header-icon-secondary) !important;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.tabsBlock {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  align-items: center;\n}\n\n.tabContainer {\n  width: 70%;\n  @media (max-width: 850px) {\n    width: 60%;\n  }\n}\n\n.skeletonTab {\n  width: 100%;\n  height: 45px;\n}\n\n.selectWrapper {\n  width: 130px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"savings": `savings__wL2Bo`,
	"savingsBlock": `savingsBlock__tKvSE`,
	"savingsCount": `savingsCount__ZFioL`,
	"savingsCountText": `savingsCountText__K6uwR`,
	"skeletonText": `skeletonText__Xx_Ih`,
	"skeleton": `skeleton__z_rii`,
	"skeletonTab": `skeletonTab__loaRu`,
	"legend": `legend__qMsUp`,
	"xAxisLabels": `xAxisLabels__X_Dzc`,
	"yAxisLabels": `yAxisLabels__AF4HL`,
	"tabsBlock": `tabsBlock__r9j0d`,
	"tabContainer": `tabContainer__s98Ev`,
	"selectWrapper": `selectWrapper__W_rME`
};
module.exports = ___CSS_LOADER_EXPORT___;
